import { Field, LayoutServiceData } from '@sitecore-jss/sitecore-jss-nextjs';

import { getSharedProperty } from '@gn-audio/jss-core';

import { parseSCLookupValue } from 'common/siteCoreHelpers';

export const getPageProduct = (layout: LayoutServiceData) => {
  const productCode = getSharedProperty(layout.sitecore.route?.fields, 'Product') as
    | Field<string>
    | undefined;
  return productCode?.value ? parseSCLookupValue(productCode.value) : undefined;
};
